export const DELETE_ISSUE_TEXTFIELD_TEST_ID =
	'issue-view-foundation.issue-actions.delete-issue.textfield';
